import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { UrlService } from 'src/app/services/Url.service';

@Component({
    selector: 'app-unauthorised-page',
    templateUrl: './unauthorised-page.component.html',
    styleUrls: ['./unauthorised-page.component.scss'],
    standalone: false,
})
export class UnauthorisedPageComponent implements OnInit {
    isUserLoggedIn: any;
    previousUrl: string = null;
    currentUrl: string = null;

    constructor(
        private urlService: UrlService,
        private msalSerice: MsalService
    ) {}

    ngOnInit(): void {
        this.isUserLoggedIn = this.msalSerice.instance.getActiveAccount();
    }

    backurl() {
        this.urlService.back();
    }
}
